import React from "react";

const UponBoxSkeleton = () => {
  const skeletonCount = 8;

  return (
    <div className="bg-gray-100 py-8 px-4">
      <h2 className="text-2xl font-bold mb-6">Open Positions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {Array.from({ length: skeletonCount }).map((_, idx) => (
          <div
            key={idx}
            className="bg-white rounded-2xl shadow-md p-4 space-y-2"
          >
            <div className="h-5 w-3/5 rounded bg-gray-300 animate-pulse"></div>
            <div className="h-4 w-2/5 rounded bg-gray-300 animate-pulse"></div>
            <div className="h-4 w-1/2 rounded bg-gray-300 animate-pulse"></div>
            <div className="h-9 w-30 rounded-md bg-gray-300 animate-pulse mt-4"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UponBoxSkeleton;
